import {itemWithoutDiscounts} from './itemWithoutDiscounts';

export const query = `query getFilteredProductsWithoutDiscounts($mainCollectionId: String!, $filters: ProductFilters, $sort: ProductSort, $offset: Int, $limit: Int, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
  catalog {
    category(categoryId: $mainCollectionId) {
      productsWithMetaData(filters: $filters, limit: $limit, sort: $sort, offset: $offset, onlyVisible: true) {
        totalCount
        list {
           ${itemWithoutDiscounts}
        }
      }
    }
  }
}
`;
